import { render } from "./vForm.vue?vue&type=template&id=0d884cb5&scoped=true"
import script from "./vForm.vue?vue&type=script&lang=js"
export * from "./vForm.vue?vue&type=script&lang=js"

import "./vForm.vue?vue&type=style&index=0&id=0d884cb5&scoped=true&lang=scss"

import exportComponent from "C:\\DevWeb\\verdon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d884cb5"]])

export default __exports__